import React, { Dispatch, Fragment } from 'react';
import { connect } from 'react-redux';
import { PadDForm, PadFDFormElement } from '../../api/pushVisit';
import onContainerClick from '../../pages/prescriptionPad/onClickContainer';
import { Actions } from '../../store/actions';
import { deleteDyForm, upsertDyForm } from '../../store/actions/prescriptionPad';
import { GDyForm } from '../../store/db';
import { GlobalState } from '../../store/reducers';
import { getPadDyForm } from '../../store/selectors/session';
import { generateDySecId } from '../../store/utils';
import DynamicCard from './DynamicCard';

interface Props {
    dispatch: Dispatch<Actions>;
    padDyForm?: GDyForm[];
}

interface State {
    newForm?: PadDForm;
    isPrintEnabled?: boolean;
}

class AddSections extends React.PureComponent<Props, State> {
    state: State = {};

    onAddSection = () => {
        const id = generateDySecId();
        this.setState({
            newForm: { id, name: '' },
            isPrintEnabled: true,
        });
    };

    onPrintChange = (isPrintEnabled: boolean) => {
        this.setState({
            isPrintEnabled,
        });
    };

    onUpdate = (name: string, elements?: PadFDFormElement[]) => {
        const { newForm } = this.state;
        const { dispatch } = this.props;
        newForm && dispatch(upsertDyForm({ id: newForm.id, name, elements }));
    };

    componentDidUpdate() {
        const { newForm } = this.state;
        if (this.props.padDyForm?.find((t) => t.id === newForm?.id)) {
            this.setState(
                {
                    newForm: undefined,
                    isPrintEnabled: undefined,
                },
                () => {
                    newForm?.id && document.getElementById(newForm?.id)?.classList.add('infocus');
                },
            );
        }
    }

    onDelete = () => {
        const { newForm } = this.state;
        this.setState({
            newForm: undefined,
            isPrintEnabled: undefined,
        });
        const { dispatch } = this.props;
        newForm && dispatch(deleteDyForm(newForm.id));
    };

    render() {
        const { newForm, isPrintEnabled } = this.state;

        return (
            <Fragment>
                {newForm ? (
                    <DynamicCard
                        key={newForm.id}
                        form={newForm}
                        onUpdate={this.onUpdate}
                        isPrintEnabled={isPrintEnabled || false}
                        onPrintChange={this.onPrintChange}
                        onDelete={this.onDelete}
                    />
                ) : (
                    <div onFocus={onContainerClick}>
                        <div
                            onClick={this.onAddSection}
                            className={`p-16 bg-white row focusable w-full rounded-8 cursor-pointer`}
                        >
                            <div className={`flex items-center`}>
                                <p className={`font-700 text-14 text-neutral-4`}>Add section:</p>
                                <div className="ml-16 cursor-pointer flex items-center">
                                    <div
                                        className={`rounded-4 w-32 mr-8 h-32 bg-darwin-primary-500 flex items-center justify-center `}
                                    >
                                        <div className="flex items-center justify-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="13"
                                                height="12"
                                                viewBox="0 0 13 12"
                                                fill="none"
                                            >
                                                <path
                                                    d="M12.1875 5.75C12.1875 6.13281 11.8867 6.40625 11.5312 6.40625H7.15625V10.7812C7.15625 11.1641 6.85547 11.4648 6.5 11.4648C6.11719 11.4648 5.84375 11.1641 5.84375 10.7812V6.40625H1.46875C1.08594 6.40625 0.8125 6.13281 0.8125 5.77734C0.8125 5.39453 1.08594 5.09375 1.46875 5.09375H5.84375V0.71875C5.84375 0.363281 6.11719 0.0898438 6.5 0.0898438C6.85547 0.0898438 7.15625 0.363281 7.15625 0.71875V5.09375H11.5312C11.8867 5.09375 12.1875 5.39453 12.1875 5.75Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <p className={`font-700 text-14 text-darwin-neutral-900`}>
                                        Custom Section
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default connect((state: GlobalState) => ({
    padDyForm: getPadDyForm(state),
}))(AddSections);
